export const GET_QUESTIONNAIRE_CARD = 'questionnaireTypes/GET_QUESTIONNAIRE_CARD';
export const SET_QUESTIONNAIRE_CARD = 'questionnaireTypes/SET_QUESTIONNAIRE_CARD';
export const GET_QUESTIONNAIRE_INTRO = 'questionnaireTypes/GET_QUESTIONNAIRE_INTRO';
export const SET_QUESTIONNAIRE_INTRO = 'questionnaireTypes/SET_QUESTIONNAIRE_INTRO';
export const GET_QUESTIONNAIRE_SECTION = 'questionnaireTypes/GET_QUESTIONNAIRE_SECTION';
export const SET_QUESTIONNAIRE_SECTION = 'questionnaireTypes/SET_QUESTIONNAIRE_SECTION';
export const GET_QUESTIONNAIRE_PAGE = 'questionnaireTypes/GET_QUESTIONNAIRE_PAGE';
export const SET_QUESTIONNAIRE_PAGE = 'questionnaireTypes/SET_QUESTIONNAIRE_PAGE';
export const SET_QUESTIONNAIRE_MENU = 'questionnaireTypes/SET_QUESTIONNAIRE_MENU';
export const RESET_QUESTIONNAIRE = 'questionnaireTypes/RESET_QUESTIONNAIRE';
export const REFRESH_MENUS = 'questionnaireTypes/REFRESH_MENUS';
export const MOVE_AWAY_TRUE = 'questionnaireTypes/MOVE_AWAY_TRUE';
export const COMPLETE_MODEL_DIALOG_OPEN_CLOSE = 'questionnaireTypes/COMPLETE_MODEL_DIALOG_OPEN_CLOSE';
export const USER_IS_ON_QUESTIONNAIRE = 'questionnaireTypes/USER_IS_ON_QUESTIONNAIRE';
export const SET_FORM_VALUES = 'questionnaireTypes/SET_FORM_VALUES';
export const SET_HAS_ERROR = 'questionnaireTypes/SET_HAS_ERROR';
export const SET_CHAT_TAB_CLICKED = 'questionnaireTypes/SET_CHAT_TAB_CLICKED';
export const SET_HOME_TAB_CLICKED = 'questionnaireTypes/SET_HOME_TAB_CLICKED';
export const SET_DOC_TAB_CLICKED = 'questionnaireTypes/SET_DOC_TAB_CLICKED';
export const SET_MOVE_AWAY_SAVE = 'questionnaireTypes/SET_MOVE_AWAY_SAVE';
export const SET_USER_PROFILE_CLICK = 'questionnaireTypes/SET_USER_PROFILE_CLICK';
export const SET_DRAWER_OPEN_CLOSE = 'questionnaireTypes/SET_DRAWER_OPEN_CLOSE';
export const SET_HELP_CLICK = 'questionnaireTypes/SET_HELP_CLICK';
export const SET_HEADER_CLICK = 'questionnaireTypes/SET_HEADER_CLICK';
export const SHOW_SPINNER = 'questionnaireTypes/SHOW_SPINNER';
export const TOGGLE_USER_GUIDE = 'questionnaireTypes/TOGGLE_USER_GUIDE';
export const UPDATE_USER_GUIDE = 'UPDATE_USER_GUIDE';
export const UPDATE_CALL_BACK_PARAM = 'UPDATE_CALL_BACK_PARAM';
export const ELEMENTED_UPDATED="Element Updated";
export const DISPLAY_POPUP="display popup";



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/state/questionnaireTypes.js